import { types } from "../types/types";

const initial = {
  asistencias: [],
  asistencia: {},
  loadingDetalle: false,
  loadingList: false,
  ultimasFechas: {
    fechaInicio: null,
    fechaFin: null,
  },
};

export const asistenciasReducer = (state = initial, action) => {
  switch (action.type) {
    case types.setLoadingList:
      return {
        ...state,
        loadingList: action.payload,
      };
    case types.setLoadingDetalle:
      return {
        ...state,
        loadingDetalle: action.payload,
      };
    case types.storeAsistencia:
      return {
        ...state,
        asistencia: action.payload,
      };
    case types.storeAsistencias:
      return {
        ...state,
        asistencias: action.payload,
      };
    case types.setUltimasFechas:
      return {
        ...state,
        ultimasFechas: action.payload,
      };

    default:
      return state;
  }
};
